import React from 'react'
import { Breadcrumbs, Typography } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

import { Link } from '@/src/i18n/navigation'

interface HolidayBreadcrumbsProps {
    items: Array<{ label: string; href?: string }>
}

const HolidayBreadcrumbs: React.FC<HolidayBreadcrumbsProps> = ({ items }) => {
    return (
        <Breadcrumbs
            aria-label="breadcrumb"
            separator={
                <NavigateNextIcon
                    fontSize="small"
                    sx={{ color: 'textColors.disabled', '[dir=rtl] &': { transform: 'scaleX(-1)' } }}
                />
            }
            sx={{ '& .MuiBreadcrumbs-separator': { mx: 0.75 } }}
        >
            {items.map(item =>
                item.href ? (
                    <Typography
                        key={item.label}
                        component={Link}
                        href={item.href}
                        sx={{
                            fontSize: '1rem',
                            color: 'textColors.subheading',
                            textDecoration: 'none',
                            '&:hover': { color: 'primary.main', textDecoration: 'underline' }
                        }}
                    >
                        {item.label}
                    </Typography>
                ) : (
                    <Typography
                        key={item.label}
                        aria-current="page"
                        sx={{ fontSize: '1rem', fontWeight: 600, color: 'textColors.primary' }}
                    >
                        {item.label}
                    </Typography>
                )
            )}
        </Breadcrumbs>
    )
}

export { HolidayBreadcrumbs }
export type { HolidayBreadcrumbsProps }
export default HolidayBreadcrumbs
